import { render } from "./StaticBackgrounds.vue?vue&type=template&id=838fbf2a&scoped=true"
import script from "./StaticBackgrounds.vue?vue&type=script&lang=js"
export * from "./StaticBackgrounds.vue?vue&type=script&lang=js"

import "./StaticBackgrounds.vue?vue&type=style&index=0&id=838fbf2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-838fbf2a"]])

export default __exports__